import { useEffect, useRef, DependencyList } from 'react';

const useEffectNextRender = (
  effect: () => void,
  deps: DependencyList,
  clearEffect?: () => void
) => {
  const didMount = useRef(false);
  const triggerNextRenderAfterInitialRender = () => {
    if (didMount.current) {
      effect();
      return;
    }
    didMount.current = true;
  };
  useEffect(() => {
    triggerNextRenderAfterInitialRender();
    return clearEffect;
  }, deps);
};

export default useEffectNextRender;
